import { Component, Inject, Input} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ScenarioSelectionModalComponent } from '../scenario-selection-modal/scenario-selection-modal.component';
import { CanvasService } from 'src/app/predictor/services/canvas.service';
import { InteractionType } from 'src/app/predictor/enums/interaction-type';
import { LinkService } from 'src/app/predictor/services/link.service';
import { APP_CONFIG, AppConfig } from 'src/app/appconfig/appconfig';
import { SimulationService } from '../../../predictor/services/simulation.service';
import { SimulationState } from '../../../predictor/enums/simulation-state';
import { PredictorModelState } from '../../../state/predictor-model/predictor-model.state';
import { Observable } from 'rxjs';
import { StudyArea } from '../../../predictor/interfaces/study-area';
import { Select } from '@ngxs/store';
import { CanvasLayer } from '../../interfaces/canvas-layer';

@Component({
  selector: 'app-debris-flow-map',
  templateUrl: './debris-flow-map.component.html',
  styleUrls: ['./debris-flow-map.component.scss'],
})
export class DebrisFlowMapComponent {
  @Select(PredictorModelState.selectedStudyAreaData) selectedStudyAreaData$!: Observable<StudyArea | null>;

  constructor(
    private dialogService: DialogService,
    private canvasService: CanvasService,
    public simulationService: SimulationService,

    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {}

  simulationState: typeof SimulationState = SimulationState;

  @Input() showControls: boolean = false;

  @Select(PredictorModelState.scenarios)
  scenarios$!: Observable<CanvasLayer[]>;

  openJiraLink(): void {
    LinkService.OpenExternalLink(this.appConfig.jiraLink);
  }

  controlIn(): void {
    this.canvasService.zoomIn();
  }

  controlOut(): void {
    this.canvasService.zoomOut();
  }

  togglePanning(): void {
    this.canvasService.togglePanning();
    this.canvasService.setCursor(InteractionType.None);
  }

  controlLayers(): void {
    this.openLayerDialog();
  }

  openLayerDialog(): void {
    this.dialogService.open(ScenarioSelectionModalComponent, {
      width: 'auto',
      header: '',
      dismissableMask: true,
      styleClass: 'bottom-rounded title-free-header',
      modal: true,
    });
  }
}
